module.exports = __webpack_public_path__ + "static/media/latest-logo.c0463903.svg";